import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ProgressState = {
  isProgressing: boolean;
};

const initialState: ProgressState = {
  isProgressing: false,
};

export const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    setStopProgress: (state) => {
      state.isProgressing = false;
    },
    setStartProgress: (state) => {
      state.isProgressing = true;
    },
    setToggleProgress: (state, action: PayloadAction<boolean>) => {
      state.isProgressing = action.payload;
    },
  },
});

export const { setStopProgress, setStartProgress, setToggleProgress } =
  progressSlice.actions;

export default progressSlice.reducer;
